import { all, fork } from 'redux-saga/effects';
import globalSagaWatcher from './globalSaga';
import carouselWatcher from '../CommonComponents/Carousel/sagas';
import recommendAnExchangeWatcher from '../Epics/Investments/Pages/RecommendFlow/sagas';
import investmentDashboardWatcher from '../Epics/Investments/Pages/InvestmentDashboard/sagas';
import investmentOptionDetailsWatcher from '../Epics/Investments/Pages/InvestmentOptionDetails/sagas';
import exchangeActivityWatcher from '../Epics/Investments/Pages/ViewInvestmentExchangeActivity/sagas';
import grantAgreementWatcher from '../Epics/Grants/Pages/GrantAgreement/sagas';
import RecommendGrant from '../Epics/Grants/Pages/RecommendGrant/sagas';
import needAssistance from '../CommonComponents/Header/Component/NeedAssistance/saga';
import myAccount from '../Epics/MyAccounts/sagas';
import OPAWatcher from '../Epics/NPA/Pages/sagas';
import documentCentreWatcher from '../Epics/DocumentCentre/Pages/sagas';
import grantsActivityWatcher from '../Epics/Grants/Pages/GrantsActivity/sagas';
import makeAContributionWatcher from '../Epics/Contributions/Pages/MakeAContribution/sagas';
import AccountSummary from '../Epics/AccountSummary/Pages/sagas';
import AdminSearch from '../Epics/AdminSearch/Pages/sagas';
import MessagingSaga from "../Epics/Messaging/sagas";
import contributionActivity from "../Epics/Contributions/Pages/ContributionActivity/sagas";
import contributionSagaWatcher from "../Epics/Contributions/Pages/ContributionsDashboard/sagas";
import grantsSagaWatcher from "../Epics/Grants/Pages/GrantsDashboard/sagas";
import tiffWatcher from "../Epics/Investments/Pages/RecommendFlow/Containers/TIFF/sagas";
import suggestACharityWatcher from "../Epics/Grants/Pages/SuggestACharity/sagas";
import TransactionSummary from '../Epics/TransactionSummary/Pages/sagas';
import howItWorksSagaWatcher from '../Epics/Grants/Pages/HowItWorks/sagas';
import financialAdvisorSagaWatcher from '../Epics/FinancialAdvisor/sagas';
import zipCodeWatcher from '../CommonComponents/Zipcode/sagas';

export default function* rootRunner() {
  yield all([
    fork(carouselWatcher),
    fork(grantsActivityWatcher),
    fork(globalSagaWatcher),
    fork(recommendAnExchangeWatcher),
    fork(investmentDashboardWatcher),
    fork(myAccount),
    fork(investmentOptionDetailsWatcher),
    fork(grantAgreementWatcher),
    fork(RecommendGrant),
    fork(OPAWatcher),
    fork(needAssistance),
    fork(AccountSummary),
    fork(AdminSearch),
    fork(exchangeActivityWatcher),
    fork(MessagingSaga),
    fork(documentCentreWatcher),
    fork(makeAContributionWatcher),
    fork(contributionActivity),
    fork(contributionSagaWatcher),
    fork(grantsSagaWatcher),
    fork(TransactionSummary),
    fork(howItWorksSagaWatcher),
    fork(tiffWatcher),
    fork(suggestACharityWatcher),
    fork(financialAdvisorSagaWatcher),
    fork(zipCodeWatcher)
  ]);
}
